<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">加入班级</span>
            </template>
            <template #left>
                <router-link to="/">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/">
                    <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
                </router-link>
            </template>
        </van-nav-bar>

        <van-empty v-if="!currentClass.id" description="班级不存在，请检查二维码是否正确或已失效" />

        <div v-if="currentClass.id">
            <div :style="{textAlign:'center'}">
                <van-icon name="question" color="#ee0a24" size="100px"/>
                <br>
                您即将加入班级:<br><br>
                {{ currentClass.name }}<br>
                所属科目：<span :style="{color:'#ee0a24'}">{{ currentClass.subject.name }}</span><br>
                学习时间：{{
                    currentClass.start_time | datefmt('YYYY-MM-DD')
                }}至{{ currentClass.expired_time| datefmt('YYYY-MM-DD') }}
            </div>
            <van-divider v-if="NeedCompleteInformation">完善个人信息</van-divider>

            <van-form label-width="120" @submit="CompleteInformation">
                <van-field v-if="NeedCompleteInformation"
                           v-model="user.name" name="user_id" label="姓名:" placeholder="姓名"
                           :rules="[{ required: true, message: '请输入姓名' }]"/>
                <van-field v-if="NeedCompleteInformation"
                           v-model="user.id_card" name="id_card" label="身份证号码:" placeholder="身份证号码"
                           :rules="[{ required: true, message: '请输入身份证号码' }]"/>
                <van-field v-if="NeedCompleteInformation"
                           v-model="user.phone" name="phone" label="手机号:" placeholder="手机号"
                           :rules="[{ required: true, message: '请输入手机号' }]"/>
                <van-field v-if="NeedCompleteInformation"
                           v-model="user.work_unit" name="work_unit" label="工作单位:" placeholder="工作单位"
                           :rules="[{ required: false }]"/>

                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit">确认加入班级</van-button>
                </div>
            </van-form>
        </div>


        <van-dialog v-model="loading" title="" :show-confirm-button="false">
            <br>
            <van-loading size="50px" vertical>{{ loading_text }}</van-loading>
            <br>
        </van-dialog>


    </div>
</template>

<script>
export default {
    data() {
        return {
            user: {},
            currentClass: {},
            joinedClass: [],
            loading: false,
            NeedCompleteInformation: true,
            loading_text: "提交中",
        };
    },
    created() {
        if (undefined === this.$route.query.class_no || "" === this.$route.query.class_no) {
            //
        } else {
            this.getClassDetails(this.$route.query.class_no)
        }
        this.getUserDetails();
    },
    methods: {
        getUserDetails() {
            this.$http.get("/wechat/user/details").then(res => {
                console.log(res.data);
                if (200 === res.data.code) {
                    if (res.data.data.user.id_card.length > 0 && res.data.data.user.phone.length > 0) {
                        this.NeedCompleteInformation = false
                    }
                    this.user = res.data.data.user

                }
            });
        },
        getClassDetails(classNo) {
            this.$http.get("/wechat/class/details/" + classNo).then(res => {
                console.log(res.data);
                if (200 === res.data.code) {
                    this.currentClass = res.data.data
                }
            });
        },
        //完善个人资料
        CompleteInformation() {
            if (!this.NeedCompleteInformation) {
                this.JoinClass();
                return
            }
            console.log(this.user)
            if (this.user.id_card.length <= 0 || this.user.phone.length <= 0) {
                this.$toast.fail("请完善个人信息");
                return false
            }
            this.loading = true
            this.$http.post("/wechat/user", this.user).then(res => {
                this.loading = false
                console.log(res.data);
                if (200 !== res.data.code) {
                    this.$toast.fail(res.data.msg);
                    return
                }

                this.JoinClass();
            });
        },
        JoinClass() {
            this.loading = true
            this.$http.get("/wechat/class/join/" + this.currentClass.number).then(res => {
                this.loading = false
                console.log(res.data);
                if (200 !== res.data.code) {

                    this.$dialog.confirm({
                        title: '加入失败',
                        message: res.data.msg,
                        confirmButtonText:'确认',
                        cancelButtonText:'取消',
                    }).then(() => {

                    }).catch(() => {

                    });
                    return
                }
                // this.$toast.success("提交成功")
                this.$dialog.confirm({
                    title: '提示',
                    message: '加入成功',
                    confirmButtonText:'去课程学习',
                    cancelButtonText:'去首页',
                }).then(() => {
                    this.$router.push('/courses');
                }).catch(() => {
                    this.$router.push('/');
                });
            });
        },
    }
}
</script>
